export default __webpack_public_path__ + "static/lets-talk-0459e0c512db3e2a2503493a7f8f4624.svg";